import React, { Suspense } from "react";

import { StaticImage } from "gatsby-plugin-image";
import { Trans } from "gatsby-plugin-react-i18next";

import { Logo } from "components/Logo";
import { Reserve } from "components/Reserve";
import { SNSButtons } from "components/SNSButtons";

import { Links } from "libs/constants";

export const Footer = () => {
	// noinspection AllyJsxHardcodedStringInspection
	return (
		<div className="md:grid">
			<Suspense
				fallback={
					<StaticImage
						src="../images/ready-bg.png"
						alt=""
						layout="fullWidth"
						className="hidden col-span-full row-span-full -z-10 md:block"
					/>
				}
			>
				<StaticImage
					src="../images/ready-bg.png"
					alt=""
					layout="fullWidth"
					className="hidden col-span-full row-span-full -z-10 md:block"
				/>
			</Suspense>
			<div className="contents md:flex md:flex-col col-span-full row-span-full">
				<div className="grid">
					<StaticImage
						src="../images/ready-bg-m.png"
						alt=""
						layout="fullWidth"
						placeholder="blurred"
						className="col-span-full row-span-full -z-10 md:hidden"
					/>
					<section className="col-span-full row-span-full flex flex-col items-center pt-[22vw] lg:pt-[10vw]">
						<h2
							className="text-shadow-purple font-bold leading-none italic text-[25px] text-center
							[&_strong]:text-[36px] md:text-[68px] md:[&_strong]:text-[100px]"
						>
							<Trans i18nKey="heading.ready" />
						</h2>
					</section>
				</div>
				<footer className="grid -mt-[45vw] md:block md:mt-auto">
					<StaticImage
						src="../images/footer-bg-m.png"
						alt=""
						layout="fullWidth"
						objectPosition="50% 100%"
						className="col-span-full row-span-full -z-20 md:hidden"
					/>
					<div className="flex flex-col pb-4 col-span-full row-span-full md:pt-0">
						<div className="mx-auto pt-[20vw] md:pt-0">
							<Reserve />
						</div>
						<nav className="flex justify-center space-x-4 my-4">
							<div className="w-[139px] h-[60px] bg-[#1B2546CC] rounded flex justify-center items-center gap-3 pb-[1px]">
								<h4 className="text-[18px] font-bold leading-[22px] tracking-[4px] drop-shadow mt-[4px]">公式</h4>
								<SNSButtons />
							</div>
						</nav>
						<div className="flex flex-col items-center text-sm leading-22 tracking-wide my-4">
								<p>Android 推奨スペック</p>
								<p>OS：Android 9 以上</p>
								<p>ROM ストレージ：空き容量 2.5 GB 以上</p>
								<p>RAM：6 GB 以上</p>
								<p>CPU：Snapdragon 730、Exynos 8895 以上</p>
								<p>※記載されている環境以外での動作保証は致しかねます。</p>
						</div>
						<div className="flex flex-col items-center text-sm leading-22 tracking-wide my-4">
								<p>DMM GAME PLAYER版</p>
								<p>対応OS：Windows 10 64-bit、11</p>
								<p>CPU：Dual-Core 2.4GHz以上必須 / Intel Core i5 以上推獎</p>
								<p>メモリ：4GB以上必須 / 8GB以上推奨</p>
								<p>グラフィック：GeForce GTS 450 以上必須 / GeForce GTX 750 以上推獎</p>
								<p>備考	DirectX:11以上必須</p>
								<p>※すべての端末での動作を保障するものではございません。</p>
						</div>
						<div className="flex flex-col items-center text-sm leading-22 tracking-wide my-4">
								<p className="my-1">ゲーム情報</p>
								<p className="my-1">ゲーム名称：星欲少女</p>
								<p className="my-1">ジャンル：シューティング、アクション</p>
								<p className="my-1">対応言語: 日本語</p>
								<p className="my-1">ゲーム価格：無料（ゲーム内課金あり）</p>
						</div>
					</div>
				</footer>
			</div>
			<div>
				<div className="flex items-center justify-center mt-auto mb-2 md:my-8 lg:mt-8">
					<div className="w-[326px]">
						<Logo />
					</div>
					<StaticImage
						src="../images/logo-ice-cone.png"
						alt="Ice cone logo"
						width={170}
					/>
				</div>
				<nav className="text-center">
					<ul className="flex justify-center mb-2 text-xs leading-none divide-x">
							<li className="px-1">
								<a target="_blank" rel="noreferrer" href={Links.Terms}>
									利用規約
								</a>
							</li>
							<li className="px-1">
								<a target="_blank" rel="noreferrer" href={Links.Policy}>
									個人情報保護方針
								</a>
							</li>
						</ul>
						<ul className="flex justify-center mb-2 text-xs leading-none divide-x">
							<li className="px-1">
								<a target="_blank" rel="noreferrer" href={Links.Announce}>
									特定商取引法に基づく表示
								</a>
							</li>
							<li className="px-1">
								<a target="_blank" rel="noreferrer" href={Links.Contact}>
									お問い合わせ
								</a>
							</li>
					</ul>
					<p className="text-xs">※お問い合わせに対してメールでご連絡するため、そのメールを受け取れるように</p>
				</nav>
				<small className="block text-xs text-center p-4 my-4">
					©2024 ~ 2026 ICECONE CO., LTD. / Star Lusts™
				</small>
			</div>
		</div>
	);
};
